import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[floatingMenuAnchor]',
})
export class FloatingMenuAnchorDirective {
  readonly element = inject(ElementRef<HTMLElement>);
}
